import type { AppRedirect } from '#src/shared/routes';

export const REDIRECTS: readonly AppRedirect[] = [
	{
		path: '/admin',
		buildUrl: ({ queryString }) => `/v2/admin${queryString}`,
	},
	{
		path: '/admin/bulk_unsubscribe',
		buildUrl: ({ queryString }) => `/v2/admin/bulk_unsubscribe${queryString}`,
	},
	{
		path: '/admin/staff',
		buildUrl: ({ queryString }) => `/v2/admin/staff${queryString}`,
	},
];
